const analyticsPageEvents = {
    ENTRY: "ENTRY",
    EVENT: "EVENT",
};

// GA Constants
const GaEvents = {
    GENERIC_EVENT: "event",
    PAGE_VIEW_EVENT: "logPageview",
};

const GaCategories = {
    API_RESPONSE: "Api_Response",
    EVOX: "Evox",
    APPOINTMENT: "Appointment",
    SERVICE_LOCATION: "service-location",
};

const GaActions = {
    RESULT: "Result",
    CLICKED: "Clicked",
    VIF: "vif",
    SUBMITTED: "Submitted",
    DISPLAYED: "Displayed",
    CASH_QUOTE_DISPLAYED: "Cash quote displayed",
    MOBILE_AVAILABLE: "mobile_available",
    SHOPS_FIRST_DISPLAYED: "shops_first_displayed",
    MORE_LOCATIONS_CLICKED: "more_locations_clicked",
};

const GaLabels = {
    SUCCESS: "Success",
    ERROR: "Error",
    LICENSE_PLATE_LOOKUP: "License_Plate_Look_Up",
    VIN_LOOKUP: "Vin_Look_Up",
    ADDRESS_LOOKUP: "Address_Look_up",
    YES: "yes",
    NO: "no",
};

const ValueToLogTypes = {
    LAST_5: "last_5",
};

export { analyticsPageEvents, GaCategories, GaActions, GaLabels, GaEvents, ValueToLogTypes };
